import NeoFlashLinearProgressBar from "./NeoFlashLinearProgressBar";
import NeoFlashQuestionProgressText from "../../texts/flashScreen/NeoFlashQuestionProgressText";

export default function NeoFlashProgressBar({currentQuestion, totalQuestion}) {
    // Used in NeoFlashTopBar to display flash progress

    // BUILD
    return (
        <div className={"mt-[16px] sm:w-[240px] md:w-[320px] flex space-x-[12px] items-center"}>
            <NeoFlashQuestionProgressText currentQuestion={currentQuestion}
                                       totalQuestion={totalQuestion} />
            <NeoFlashLinearProgressBar progression={currentQuestion}
                                     total={totalQuestion} />

        </div>
    );
}